import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const MinimalNavTest: React.FC = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const navItems = [
    { name: 'Dashboards', href: '/dashboards', subItems: [
      { name: 'Executive Dashboard', href: '/dashboards' },
      { name: 'Orders Dashboard', href: '/dashboards/orders' }
    ]},
    { name: 'Inventory', href: '/inventory', subItems: [
      { name: 'Stock Levels', href: '/inventory' },
      { name: 'Catalog', href: '/catalog' }
    ]}
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Minimal Navigation Test</h1>
        
        {/* Debug Info */}
        <div className="bg-yellow-100 border border-yellow-400 rounded-lg p-4 mb-8">
          <h3 className="font-semibold text-yellow-800">Debug Info:</h3>
          <p className="text-yellow-700">Hovered Item: <strong>{hoveredItem || 'None'}</strong></p>
          <p className="text-yellow-700">Check browser console for hover events</p>
        </div>

        {/* Navigation */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Navigation Test</h2>
          <div className="flex space-x-4">
            {navItems.map((item) => (
              <div 
                key={item.name}
                className="relative"
                onMouseEnter={() => {
                  console.log('Hovering over:', item.name);
                  setHoveredItem(item.name);
                }}
                onMouseLeave={() => {
                  console.log('Leaving:', item.name);
                  setHoveredItem(null);
                }}
              >
                <NavLink
                  to={item.href}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                  <span>{item.name}</span>
                  <span className="text-xs">▼</span>
                </NavLink>
                
                {item.subItems && hoveredItem === item.name && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                    {item.subItems.map((subItem) => (
                      <NavLink
                        key={subItem.href}
                        to={subItem.href}
                        onClick={() => {
                          console.log('Subitem clicked:', subItem.name, subItem.href);
                          setHoveredItem(null);
                        }}
                        className="block px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700"
                      >
                        {subItem.name}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Instructions */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="font-semibold text-blue-800 mb-2">Test Instructions:</h3>
          <ol className="list-decimal list-inside text-blue-700 space-y-1">
            <li>Hover over "Dashboards" or "Inventory" buttons</li>
            <li>You should see a dropdown appear</li>
            <li>Click on any subitem to navigate</li>
            <li>Check the browser console for debug messages</li>
            <li>Check the debug info box above for hover state</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default MinimalNavTest;
